export function trackMeta(eventName, parameters) {
    try {
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
            window.fbq("track", eventName, parameters || {});
        }
    } catch (error) {
        if (process.env.NODE_ENV === "development") {
            console.warn("Meta Pixel unavailable", error);
        }
    }
}
